import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
const _ = require('lodash');
import * as $ from 'jquery';

import { CommonService } from './../../../../services/common/common.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { SeedReplantService } from '../../../../services/seed/seed-replant/seed-replant.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';

@Component({
  selector: 'app-seed-replant-review',
  templateUrl: './seed-replant-review.component.html',
  styleUrls: ['./seed-replant-review.component.scss']
})
export class SeedReplantReviewComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('failedPaginator', { read: MatPaginator }) failedPaginator: MatPaginator;
  @ViewChild('replantPaginator', { read: MatPaginator }) replantPaginator: MatPaginator;

  subscription = new Subscription();
  masterConstants = MasterConstants;
  dashboardFilter: DashboardFilter;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  requestHeaderId = 0;
  webOrderNumber: any;
  breadcrumbtext: string;
  soldToAccount: number;
  soldToDataLoading: any;
  soldToAccountList: any[];
  shipToAccountList: any[];
  shipToAccount: number;
  shipToAccountName: number;
  shipToDataLoading: any;
  readOnlyAccess = false;
  creditToList: any[];
  creditToAccount: number;
  creditToDataLoading: any;
  creditToAnotherLocation = false;
  growerList: any;
  growerGMK: number;
  growerLoading: any;
  requestedBy: string;
  requestOnBehalfList: any = [];
  emailAddress: string;
  isNotValid = false;
  productItemsDataSource: any;
  displayedColumns: string[] = ['product', 'treatment', 'lotNumber', 'eligibleUnits', 'unitsSoldToGrower', 'failedUnits', 'uom', 'problemDescription', 'approverNotes'];
  replantDisplayedColumns: string[] = ['product', 'treatment', 'lotNumber', 'eligibleUnits', 'unitsCredited', 'uom', 'problemDescription', 'approverNotes'];
  replantProductItemsDataSource: any;
  agreeToTermsAndConditions = false;
  isApproverUser = false;
  isViewRequest = false;
  isShowNonSubEmail = true;
  isAutoApprove: boolean = false;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private loaderService: LoaderService,
    private seedReplantService: SeedReplantService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private broadcastService: BroadcastService,
    private configService: ConfigService
  ) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit(): void {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }
      }
    }
    this.subscription.add(this.seedReplantService.reviewRequestId.subscribe(x => {
      if (x) {
        this.requestHeaderId = x;
        this.getOrderDetails();
      } else {
        this.router.navigate(['/']);
      }
    }));

    this.isApproverUser = this.seedReplantService.isApproverUser;
    this.isViewRequest = this.seedReplantService.isViewRequest;

    this.productItemsDataSource = new MatTableDataSource([]);
    this.replantProductItemsDataSource = new MatTableDataSource([]);
  }

  // Set page breadcrumb text
  setBreadcrumbText() {
    this.breadcrumbtext = `${this.isApproverUser ? 'Approve Request' : (this.isViewRequest ? 'View Request' : 'Review Request')} [${this.webOrderNumber}]`;
  }

  loadMasterData() {
    this.loaderService.setLoaderStatus(true);

    const forkJoinAPIs = [];
    forkJoinAPIs.push(this.seedReplantService.getShipToAccountDataList());
    forkJoinAPIs.push(this.seedReplantService.getAccountUser(0));
    this.subscription.add(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
      this.shipToAccountList = result[0];
      this.requestOnBehalfList = result[1];
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getUserList(accountNumber) {
    this.subscription.add(this.seedReplantService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        this.requestOnBehalfList = result;
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.seedReplantService.isApproverUser = false;
    this.seedReplantService.isViewRequest = false;
  }

  navigateToLandingPage() {
    this.router.navigate(['/seed-replant-landing']);
    this.commonService.currentTabIndex.next(1);
  }

  getGrowerListByAccount() {
    this.growerLoading = true;
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.shipToAccount = this.shipToAccount;
    const growerFilters = { 'GrowerGLN': '', 'GrowerName': '' };
    this.subscription.add(this.seedReplantService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
      this.growerList = result;
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedReplantService.getEditDetail(this.requestHeaderId, 0).subscribe((result: any) => {
      const rowId = 0;
      if (result.failedProductList && result.failedProductList.length > 0) {
        result.failedProductList.forEach(x => {
          x.rowId = rowId + 1;
          x.isSelected = false;
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
        });
      }

      this.webOrderNumber = result.webOrderNumber;
      this.shipToAccount = result.shipToAccount;

      this.getGrowerListByAccount();

      this.seedReplantService.setSelectedAccountNo(this.shipToAccount);
      this.shipToAccountList = [result.shipToAccountDetail];
      this.soldToAccountList = [result.soldToAccountDetail];
      this.soldToAccount = Number(result.shipToAccountDetail.soldTo);

      this.creditToAccount = result.creditToAccountNumber;
      this.creditToAnotherLocation = result.creditToAccountNumber ? true : false;
      this.growerGMK = result.gmk;

      this.productItemsDataSource = new MatTableDataSource(result.failedProductList);
      this.productItemsDataSource.paginator = this.failedPaginator;
      this.productItemsDataSource.paginator.firstPage();

      this.replantProductItemsDataSource = new MatTableDataSource(result.replantProductList);
      this.replantProductItemsDataSource.paginator = this.replantPaginator;
      this.replantProductItemsDataSource.paginator.firstPage();

      this.setBreadcrumbText();

      if (this.creditToAccount) {
        const shipToAccountDetail = this.shipToAccountList.find(x => x.accountNumber == this.shipToAccount);
        this.subscription.add(this.seedReplantService
          .getCreditToAccounts(shipToAccountDetail.accountNumber, shipToAccountDetail.parentNumber)
          .subscribe((result) => {
            this.creditToList = result;
            this.loaderService.setLoaderStatus(false);
          },
            error => this.loaderService.setLoaderStatus(false)));
      }

      this.requestedBy = result.requestedBy;
      this.emailAddress = this.isShowNonSubEmail ? result.emailAddress : result.userEmail;

      const parentNumber = this.shipToAccountList.find(x => x.accountNumber === this.shipToAccount).parentNumber;
      this.getUserList(parentNumber);
      this.isAutoApprove = result.hasAutoApprove;
      
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // set account table height
  setAccSummaryTableHeight() {
    const tableHeight = window.innerHeight - 50;
    $('.requestCOIOuter').css('height', tableHeight + 'px');
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  editRequest(isApprover) {
    if (isApprover == 1) {
      this.router.navigate(['/seed-replant-request-entry', this.requestHeaderId, isApprover]);
    }
    else {
      this.router.navigate(['/seed-replant-request-entry', this.requestHeaderId, 0]);
    }
  }

  // Generate PDF
  generatedPdf() {
    this.seedReplantService.generatePdf(this.requestHeaderId);
  }

  submitRequest() {
    this.loaderService.setLoaderStatus(true);
    const postData = {
      RequestHeaderId: this.requestHeaderId,
      AgreeToTermsAndConditions: this.agreeToTermsAndConditions
    };

    this.subscription.add(this.seedReplantService.submitReviewRequest(postData).subscribe((result: any) => {
      if (result) {
        this.toastrService.success('Seed Replant Review request saved successfully.');

        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });

        this.loaderService.setLoaderStatus(false);

        this.navigateToLandingPage();
      } else {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Seed Replant Review request not submitted due to missing Configuration. Contact Winfield Customer Service at 1-855-494-6343 with questions.');
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Seed Replant Review request not saved in the system.');
    }));
  }

  hasDataChanged() {
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasSeedReplantDataChange: true });
  }

  approverAction(action, isSubmitCredit = false) {
    this.loaderService.setLoaderStatus(true);
    const postData = {
      RequestHeaderId: this.requestHeaderId,
      RequestStatus: action,
      FailedProductList: this.productItemsDataSource.data.map(x => ({ detailsProductId: x.detailsProductId, approverNotes: x.approverNotes })),
      ReplantProductList: this.replantProductItemsDataSource.data.map(x => ({ detailsProductId: x.detailsProductId, approverNotes: x.approverNotes }))
    };

    // Use the pricing-aware endpoint when auto-approval is enabled and action is Approved
    const approvalRequest = (isSubmitCredit && action === 'Approved')
      ? this.seedReplantService.approveReviewRequestWithPricing(postData)
      : this.seedReplantService.approveReviewRequest(postData);

    this.subscription.add(approvalRequest.subscribe((result: any) => {
      if (result) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });

        this.loaderService.setLoaderStatus(false);

        if (action == 'Save') {
          this.toastrService.success('Seed Replant request saved successfully.');
        } else {
          this.toastrService.success(`Seed Replant request ${action} successfully.`);
          this.navigateToLandingPage();
        }
      } else {
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Seed Replant request not saved in the system.');
    }));
  }

  public IsShowTreatment(element: any): boolean {
    if (element.treatment == 'JUT' && element.productLineId == '4J1') { return true; }
    return false;
  }

}
